import { notification } from 'antd'
import { attachToken, privateAPI } from '../../config/constants'
import store from '../store'

export const getTopTransactions = async () => {
  try {
    attachToken()
    const res = await privateAPI.get('/transaction/get-top-transactions')

    if (res) {
      return res?.data?.data?.topTransaction
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}

export const getAllTransactions = async (payload) => {
  try {
    attachToken()
    const res = await privateAPI.post(`/transaction/get-all-transactions`, payload)
    if (res) {
      return res?.data?.data?.transactions
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}
